export default "__VITE_ASSET__CxDnJDfb__"